export default "__VITE_ASSET__DPESdoFH__"